import { useMutation } from '@tanstack/react-query'
import { subscribeCourse } from '../services/subscribeCourse.service'
import type { SubscribeParams } from '../types/subscribe.types'

export function useSubscribeMutation() {
  return useMutation({
    mutationFn: (data: SubscribeParams) => subscribeCourse(data),
  })
}
